import React from 'react';
import FaiBox from "../../../../MuiComponents/FaiBox";
import {Grid} from "@mui/material";
import orderIssueImg from "../../../../assets/images/order_issue_img.jpg";
import FaiTypography from "../../../../MuiComponents/FaiTypography";
import theme from "../../../../assets/theme";

function ProductDetail() {
    const {typography, borders} = theme;

    return (
        <>
            <FaiBox sx={{
                backgroundColor: "#F7FAFC",
                padding: "21px",
                borderRadius: borders.borderRadius.sm
            }}>
                <FaiBox className={"product-details"} mb={3}>
                    <Grid container spacing={2}>
                        <Grid item md={4} lg={4}>
                            <FaiBox component={"img"} src={orderIssueImg}/>
                        </Grid>
                        <Grid item md={8} lg={8}>
                            <FaiBox>
                                <Grid container spacing={1}>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}>Product name</FaiTypography>
                                    </Grid>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}
                                                       sx={{fontWeight: typography.fontWeightMedium}}>Brown
                                            Cardigan</FaiTypography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}>Quantity</FaiTypography>
                                    </Grid>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}
                                                       sx={{fontWeight: typography.fontWeightMedium}}>1
                                        </FaiTypography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}>Reason of
                                            Return</FaiTypography>
                                    </Grid>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}
                                                       sx={{fontWeight: typography.fontWeightMedium}}>
                                            Didn’t fit well
                                        </FaiTypography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}>Date </FaiTypography>
                                    </Grid>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}
                                                       sx={{fontWeight: typography.fontWeightMedium}}>
                                            23 April 2024
                                        </FaiTypography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}>Price</FaiTypography>
                                    </Grid>
                                    <Grid item sm={6} md={6} sx={{paddingTop: "3px !important"}}>
                                        <FaiTypography variant={"caption"}
                                                       sx={{fontWeight: typography.fontWeightMedium}}>
                                            Rs. 1,694
                                        </FaiTypography>
                                    </Grid>
                                </Grid>
                            </FaiBox>
                        </Grid>
                    </Grid>
                </FaiBox>
                <FaiBox className={"order-summary"} mb={3}>
                    <FaiBox sx={{
                        background: "white",
                        padding: "12px 16px",
                        borderRadius: borders.borderRadius.md
                    }}>
                        <FaiBox>
                            <FaiTypography variant={"caption"} sx={{
                                fontWeight: typography.fontWeightMedium,
                                fontSize: "14px"
                            }}> Summary</FaiTypography>
                        </FaiBox>
                        <FaiBox>
                            <Grid container spacing={2}>
                                <Grid item sm={6} md={6} sx={{paddingTop: "8px !important"}}>
                                    <FaiTypography variant={"caption"}>Order Id</FaiTypography>
                                </Grid>
                                <Grid item sm={6} md={6} sx={{paddingTop: "8px !important"}}>
                                    <FaiTypography variant={"caption"}
                                                   sx={{fontWeight: typography.fontWeightMedium}}>41258</FaiTypography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item sm={6} md={6} sx={{paddingTop: "8px !important"}}>
                                    <FaiTypography variant={"caption"}>Date</FaiTypography>
                                </Grid>
                                <Grid item sm={6} md={6} sx={{paddingTop: "8px !important"}}>
                                    <FaiTypography variant={"caption"}
                                                   sx={{fontWeight: typography.fontWeightMedium}}>23
                                        April 2024</FaiTypography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item sm={6} md={6} sx={{paddingTop: "8px !important"}}>
                                    <FaiTypography variant={"caption"}>Total</FaiTypography>
                                </Grid>
                                <Grid item sm={6} md={6} sx={{paddingTop: "8px !important"}}>
                                    <FaiTypography variant={"caption"}
                                                   sx={{fontWeight: typography.fontWeightMedium}}>Rs.
                                        1,600</FaiTypography>
                                </Grid>
                            </Grid>
                        </FaiBox>
                    </FaiBox>
                </FaiBox>
                <FaiBox className={"shipping-details"} mb={3}>
                    <FaiBox sx={{
                        background: "white",
                        padding: "12px 16px",
                        borderRadius: borders.borderRadius.md
                    }}>
                        <FaiBox>
                            <FaiTypography variant={"caption"} sx={{
                                fontWeight: typography.fontWeightMedium,
                                fontSize: "14px"
                            }}> Shipping Addresses</FaiTypography>
                        </FaiBox>
                        <FaiBox>
                            <FaiBox width={"40%"}>
                                <FaiTypography variant={"caption"}> 42/1 Gandhi Road New Delhi, Delhi
                                    PIN:
                                    110001 India</FaiTypography>
                            </FaiBox>
                        </FaiBox>
                    </FaiBox>
                </FaiBox>
                <FaiBox className={"payment-methods"}>
                    <FaiBox sx={{
                        background: "white",
                        padding: "12px 16px",
                        borderRadius: borders.borderRadius.md
                    }}>
                        <FaiBox>
                            <FaiTypography variant={"caption"} sx={{
                                fontWeight: typography.fontWeightMedium,
                                fontSize: "14px"
                            }}> Payment Methods</FaiTypography>
                        </FaiBox>
                        <FaiBox>
                            <FaiBox width={"40%"}>
                                <FaiTypography variant={"caption"}> Cash on Delivery</FaiTypography>
                            </FaiBox>
                        </FaiBox>
                    </FaiBox>
                </FaiBox>
            </FaiBox>
        </>
    );
}

export default ProductDetail;
